import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const BookingConfirmation = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen pt-20 bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Card className="p-10 text-center shadow-xl border-slate-100">
          <div className="flex justify-center">
            <div className="rounded-full bg-green-100 p-4">
              <CheckCircle2 className="h-20 w-20 text-green-600" />
            </div>
          </div>
          <h1 className="mt-6 text-3xl font-bold text-slate-900">Payment Successful</h1>
          <p className="mt-2 text-lg text-slate-600">
            Thank you for your payment. Your booking is confirmed.
          </p>
          <p className="mt-2 text-sm text-slate-500">
            We have sent a confirmation email with your booking and payment details.
          </p>
          <div className="mt-8 flex justify-center">
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700"
              onClick={() => navigate('/')}
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Back to Home
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default BookingConfirmation;
